import React from 'react';
import { styled } from '@compiled/react';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import { FireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useCoreDataLimits } from '../../../../services/core-data';
import messages from './messages';

const MaxPaginationWarning = () => {
	const { formatMessage } = useIntl();
	const { hasReachedMaxIssuesLimit, hasReachedMaxDeploymentsLimit } = useCoreDataLimits();
	if (!hasReachedMaxIssuesLimit && !hasReachedMaxDeploymentsLimit) {
		return null;
	}
	const message = hasReachedMaxIssuesLimit ? messages.maxIssues : messages.maxDeployments;

	return (
		<MaxPaginationWarningWrapper>
			<Tooltip content={formatMessage(message)} position="right">
				<WarningIcon
					primaryColor={token('color.icon.warning', colors.Y400)}
					label={formatMessage(messages.warning)}
				/>
			</Tooltip>
			{hasReachedMaxIssuesLimit && <FireOperationalAnalytics eventName="issues limitReached" />}
			{hasReachedMaxDeploymentsLimit && (
				<FireOperationalAnalytics eventName="deployments limitReached" />
			)}
		</MaxPaginationWarningWrapper>
	);
};

export default MaxPaginationWarning;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const MaxPaginationWarningWrapper = styled.div({
	flexShrink: 0,
});
